module.exports = __webpack_public_path__ + "media/images/social_svgs/youtube-f44afffe970864399ee0aceb02b5af63.svg";